import { Page, Select } from 'view-design'
import { pageSizeOpts } from '@/assets/js/commonValue'

// 分页组件的默认页数切换
Page.props.pageSizeOpts.default = () => pageSizeOpts.slice()

// 分页组件的props.pageSize支持.sync
Page.methods.onSize = function(pageSize) {
  if (this.disabled) return
  this.currentPageSize = pageSize
  this.$emit('update:page-size', pageSize)
  this.$emit('on-page-size-change', pageSize)
  this.changePage(1)
}

// 选择器默认按label搜索
// Select.props.filterByLabel.default = true



// WEBPACK FOOTER //
// ./src/plugins/view-design.js